import { render, staticRenderFns } from "./BtnEstadoCaja.vue?vue&type=template&id=cb076fba&"
import script from "./BtnEstadoCaja.vue?vue&type=script&lang=js&"
export * from "./BtnEstadoCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports